var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.93916 1.05929C7.93916 0.839476 7.7355 0.661282 7.4843 0.661282L6.57456 0.661282C6.32334 0.661282 6.11968 0.839476 6.11968 1.05929L6.11968 6.1197L1.05928 6.11969C0.839467 6.11969 0.661273 6.32335 0.661273 6.57455L0.661273 7.48429C0.661273 7.73551 0.839467 7.93916 1.05928 7.93916L6.11968 7.93917L6.11968 12.9996C6.11968 13.2194 6.32334 13.3976 6.57455 13.3976H7.48429C7.7355 13.3976 7.93916 13.2194 7.93916 12.9996L7.93916 7.93917L12.9996 7.93916C13.2194 7.93916 13.3976 7.73551 13.3976 7.4843L13.3976 6.57456C13.3976 6.32335 13.2194 6.11969 12.9996 6.11969L7.93916 6.1197L7.93916 1.05929Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddButton);
export default __webpack_public_path__ + "static/media/AddButton.54fdf843052ec3e170f20fa666fe6d36.svg";
export { ForwardRef as ReactComponent };